import React, { type FC } from 'react'

interface IProps {
  className?: string
  data: string
}

const StructuredText: FC<IProps> = ({ className, data }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: data }}
    ></div>
  )
}

export default StructuredText
